import { render, staticRenderFns } from "./MiscellaneousSettings.vue?vue&type=template&id=769a71da&scoped=true"
import script from "./MiscellaneousSettings.vue?vue&type=script&lang=js"
export * from "./MiscellaneousSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769a71da",
  null
  
)

export default component.exports